module.exports = __webpack_public_path__ + "static/i-2b1019105face28670d483989224f521.png";